import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { Form, FormItemProps as AntdFormItemProps } from 'antd';
import { useIntl } from 'react-intl';
import React from 'react';

export type FormItemProps<T extends FieldValues> = UseControllerProps<T> &
  AntdFormItemProps;

export const FormItem = <TFieldValues extends FieldValues>({
  name,
  label = 'auto',
  required = true,
  children,
  ...props
}: FormItemProps<TFieldValues>) => {
  const { formatMessage } = useIntl();
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  return (
    <Form.Item
      label={
        label === 'auto'
          ? formatMessage({ id: `field.${name}` as MessageId })
          : label
      }
      required={required}
      validateStatus={error && 'error'}
      help={error?.message && formatMessage({ id: error.message as MessageId })}
      {...props}
    >
      {React.isValidElement(children) && children.type !== 'input'
        ? React.cloneElement(children, { ...field, ...children.props })
        : children}
    </Form.Item>
  );
};
